import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/email-svgrepo-com.svg'
import _imports_1 from '@/assets/github-mark.svg'


const _hoisted_1 = { class: "text-h5 text-md-h5 text-lg-h5 font-weight-bold" }
const _hoisted_2 = { class: "text-h6" }
const _hoisted_3 = { class: "text-h4 text--primary" }
const _hoisted_4 = { class: "contact-div" }
const _hoisted_5 = { class: "contact-line" }
const _hoisted_6 = { class: "contact-text" }
const _hoisted_7 = {
  key: 0,
  class: "contact-line"
}
const _hoisted_8 = { class: "contact-text" }
const _hoisted_9 = ["href"]

import { ref } from "vue";
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeveloperCard',
  props: {
    nome: {},
    nick: {},
    email: {},
    foto: {},
    descricao: {}
  },
  setup(__props: any) {

const { t } = useI18n();
const reveal = ref(false);



return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mx-auto" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_img, {
        src: _ctx.foto,
        cover: ""
      }, null, 8, ["src"]),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.nome), 1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.descricao), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: "button-contact",
            variant: "flat",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (reveal.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('aboutPage.formsOfContact')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [
          (reveal.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                class: "v-card--reveal",
                style: {"height":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('aboutPage.meansOfContact')), 1),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_v_img, {
                            src: _imports_0,
                            alt: "Logo Gmail"
                          }),
                          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.email), 1)
                        ]),
                        (_ctx.nick)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_component_v_img, {
                                src: _imports_1,
                                alt: "Logo github"
                              }),
                              _createElementVNode("label", _hoisted_8, [
                                (_ctx.nick)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: 'https://github.com/' + _ctx.nick,
                                      target: "_blank"
                                    }, _toDisplayString(_ctx.nick), 9, _hoisted_9))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        color: "teal-accent-4",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (reveal.value = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('aboutPage.close')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})